const ITEMS = ["ORGANIZE", "BRAND", "BUILD", "LAUNCH", "GROW", "REPEAT"];

export default function Marquee() {
  return (
    <div className="marquee border-y border-[#E8DCCB] py-6 bg-[#FAF6EF]" data-testid="marquee">
      <div className="marquee-track">
        {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="f-display text-3xl sm:text-4xl font-medium tracking-tight text-[#F3EAE0] [-webkit-text-stroke:1px_#E8DCCB] px-8"
              style={{ WebkitTextStroke: "1px #D9CBB9" }}>
              {item}
            </span>
            <span className="w-2 h-2 rounded-full bg-[#A8785A]" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
}
